export const Colors = {
  bg1: '#13263C',
  fg1: '#DACEA7',
  fg2: '#B1A374',
  fg3: '#A1A7AF',
  orange: '#E69138',
  red: '#C44900',
  green: '#1A936F',
  outage: 'rgba(105, 72, 115, 0.9)',
  floatingIdle: 'rgba(128, 128, 128, 0.8)',
  fixedIdle: 'rgba(0, 0, 0, 0.8)',
  repairBlock: 'rgba(255, 0, 0, 0.8)',
  swatches: [
    ['#980000', '#ff0000', '#ff9900', '#ffff00', '#00ff00', '#00ffff', '#4a86e8', '#0000ff', '#9900ff'],
    ['#dd7e6b', '#ea9999', '#f9cb9c', '#ffe599', '#b6d7a8', '#a2c4c9', '#a4c2f4', '#9fc5e8', '#b4a7d6'],
    ['#cc4125', '#e06666', '#f6b26b', '#ffd966', '#93c47d', '#76a5af', '#6d9eeb', '#6fa8dc', '#8e7cc3'],
    ['#a61c00', '#cc0000', '#e69138', '#f1c232', '#6aa84f', '#45818e', '#3c78d8', '#3d85c6', '#674ea7'],
    ['#85200c', '#990000', '#b45f06', '#bf9000', '#38761d', '#134f5c', '#1155cc', '#0b5394', '#351c75'],
    ['#5b0f00', '#660000', '#783f04', '#7f6000', '#274e13', '#0c343d', '#1c4587', '#073763', '#20124d']
  ]
}

export const Config = {
  minutesPerStep: [1, 2, 5, 10, 15, 20, 30, 60, 120, 180, 240, 360, 720, 1440],
  hoursPerRuler: 48,
  distanceBetweenTitles: 80,
  initialZoom: 120,
  graduationStep: 20,
  canvasHeight: 150
}

export const Time = {
  unix: 'x',
  date: 'YYYY-MM-DD',
  hour: 'HH:00',
  time: 'LT',
  datetime: 'YYYY-MM-DD LT',
  picker: 'yyyy-mm-dd H:ii P',
  graduationTime: 'ha',
  graduationDate: ' D-MMM'
}

export const App = {
  name: 'BOSS40',
  version: 'v.4.1.7'
}
